import React from 'react';
import style from './ReactMarkdownDisplay.scss';
import ReactMarkdown from 'react-markdown';
import { getMarkdown, transformImageUri } from './utils';
import { transformToWixDocsUrlMapping } from '../../../../utils/locationUtils/transformToWixDocsUrlMapping';
import { connectStore } from '../../../appContext/StoreProvider/ConnectStore';
import { withRouter } from 'react-router';
import { githubSluggify, parseHtml, sectionize } from './plugins';
import { defaultRenderers } from './defaultRenderers';
import { getMarkdownPath } from '../../../../utils/markdownUtils';
import { withLogger } from '../../../appContext/LoggerProvider';
import ErrorBoundary from '../../ErrorBoundary';
import gemoji from 'remark-gemoji';
import gfm from 'remark-gfm';

class _ReactMarkdownDisplay extends React.Component {
  shouldComponentUpdate() {
    return window.__IS_BOT__ || !!this.props.allowRerenders;
  }

  render() {
    return (
      <div
        className={`${style.reactMarkdownWrapper} ${
          this.props.className ? this.props.className : ''
        }`}
      >
        <ErrorBoundary>{this.renderMarkdown()}</ErrorBoundary>
      </div>
    );
  }

  renderMarkdown() {
    const {
      renderers,
      dataHooks,
      markdown,
      store,
      prefix,
      textSize,
      textLight,
      mdUrlFormat,
      mdName,
      textWeight,
      logger,
    } = this.props;

    const markdownPath = getMarkdownPath(mdName, prefix);

    return (
      <ReactMarkdown
        source={getMarkdown(markdown)}
        transformImageUri={transformImageUri(store, this.props.location)}
        transformLinkUri={transformToWixDocsUrlMapping(
          store,
          this.props.location.pathname,
          prefix,
          mdUrlFormat,
        )}
        escapeHtml={false}
        astPlugins={[
          githubSluggify(),
          parseHtml({
            textLight,
            dataHooks,
            markdownPath,
            logger,
            store,
          }),
          sectionize(markdownPath),
        ]}
        plugins={[
          [
            require('gridsome-plugin-remark-youtube'),
            { width: '500px', align: 'auto' },
          ],
          [gemoji],
          [gfm],
        ]}
        renderers={{
          ...defaultRenderers(dataHooks, {
            markdownPath,
            textSize,
            textLight,
            textWeight,
            logger,
            store,
          }),
          ...renderers,
        }}
      />
    );
  }
}

export const ReactMarkdownDisplay = withRouter(
  connectStore(withLogger(_ReactMarkdownDisplay)),
);
